function readColor(value) {
    return typeof value === "string" && value.length > 0 ? value : undefined;
}
export function resolveCandleStyleColors(series) {
    const style = series.style;
    const borderUp = readColor(style?.borderUp);
    const borderDown = readColor(style?.borderDown);
    const wickUp = readColor(style?.wickUp);
    const wickDown = readColor(style?.wickDown);
    return {
        stroke: borderUp || borderDown ? (_datum, isUp) => (isUp ? borderUp : borderDown) : undefined,
        wickStroke: wickUp || wickDown ? (_datum, isUp) => (isUp ? wickUp : wickDown) : undefined,
    };
}
